const HOTJAR_ID = 6530033;
const HOTJAR_VERSION = 6;

let initialized = false;

export function initializeHotjar(): void {
  if (typeof window === "undefined" || initialized) {
    return;
  }

  const w = window as any;

  if (w._hjSettings && w._hjSettings.hjid === HOTJAR_ID) {
    initialized = true;
    return;
  }

  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_VERSION };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(w, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

  initialized = true;
}

export function trackHotjarState(path: string): void {
  if (typeof window === "undefined") {
    return;
  }

  const w = window as any;

  if (typeof w.hj === "function") {
    w.hj("stateChange", path);
  }
}
